import React, { PureComponent } from "react";
import Page from "./../Page";

export default class Restocking extends PureComponent {
  render() {
    return <Page toolBarTitle="Réassort" pageTitle="Réassort" />;
  }
}
